import type { ReactNode } from "react";
import { Link } from "react-router";

import { Emblem } from "@/components/brand/Emblem";

/** Brand bar shared by account screens. The in-game HUD (M4+) has its own layout. */
export function TopBar({ children }: { children?: ReactNode }) {
  return (
    <header className="relative z-10 flex h-18 items-center justify-between gap-4 px-4 sm:px-8">
      <Link to="/" className="flex items-center gap-3 rounded-lg">
        <Emblem className="size-10" />
        <span className="text-headline-sm font-extrabold uppercase leading-none tracking-tight">
          Coal City Life
        </span>
      </Link>
      <div className="flex items-center gap-3">{children}</div>
    </header>
  );
}